// Gemeinsame Provider der drei Plattformen: Router-Link für @bar/ui, Theme (mit Konto-Spiegel),
// (Locale und APP_TODAY der Formatierer setzt der Plattform-Start, app/bootstrap.tsx). Auch für
// öffentliche Seiten außerhalb der Shell (Login, Galerie).
import {
  type LinkComponentProps,
  LinkProvider,
  ThemeProvider,
  type ThemePreference,
} from '@bar/ui/basis';
import { type ReactNode, useCallback } from 'react';
import { Link } from 'react-router';
import { coreApi } from '@web/lib';

/** Router-Link; volle Navigation bei `reload`, absoluten URLs und Ankern. */
export function PlatformLink({ href, reload, replace, children, ...rest }: LinkComponentProps) {
  if (reload || /^[a-z][a-z0-9+.-]*:/i.test(href) || href.startsWith('#')) {
    return (
      <a href={href} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <Link to={href} replace={replace} {...rest}>
      {children}
    </Link>
  );
}

/**
 * `syncAccount`: Theme-Wechsel auch im Konto speichern (F-konten-10). Nur in den Shells, nicht auf
 * öffentlichen Seiten (Galerie, Login); ohne Kern bleibt es bei localStorage.
 */
export function PlatformProviders({
  children,
  syncAccount = false,
}: {
  children: ReactNode;
  syncAccount?: boolean;
}) {
  const persistTheme = useCallback((theme: ThemePreference) => {
    void coreApi.updateMe({ theme }).catch(() => undefined);
  }, []);
  return (
    <ThemeProvider onPreferenceChange={syncAccount ? persistTheme : undefined}>
      <LinkProvider component={PlatformLink}>{children}</LinkProvider>
    </ThemeProvider>
  );
}
